import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faUser } from '@fortawesome/pro-solid-svg-icons';

export default function ContactIcon({ contact, size }) {
  return (
    <span className={classNames('avatar', size && `avatar-${size}`)}>
      <span className="avatar-fallback">
        {contact.initials || <FontAwesomeIcon icon={contact.isBusiness ? faBriefcase : faUser} />}
      </span>
    </span>
  );
}

ContactIcon.propTypes = {
  contact: PropTypes.shape({
    initials: PropTypes.string,
    isBusiness: PropTypes.bool,
  }).isRequired,
  size: PropTypes.string,
};
